import type { NextRouter } from "next/router"

export const updateQueryParams = ({
  params,
  router,
  shallow = true,
}: {
  params: Record<string, string>
  router: NextRouter
  shallow?: boolean
}) => {
  const { query, pathname } = router

  return router.push(
    {
      pathname,
      query: { ...query, ...params },
    },
    undefined,
    { shallow }
  )
}
